import React from 'react';

export default ({user, ...props}) =>(
     <div className="rounded rounded-md overflow-hidden shadow shadow-md bg-white max-w-xs my-3 p-3">
          {/*<img src="https://i.imgur.com/dYcYQ7E.png" className="w-full" />*/}
          <div className="flex justify-center mt-3">
               {!user.avatar && (<img src={`https://ui-avatars.com/api/?name=${user.name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={user.name} className="h-16 w-16 rounded-full" />)}
               {user.avatar && (<img src={user.avatar} alt={user.name} className="h-16 w-16 rounded-full" />)}
          </div>
          <div className="text-center px-3 pb-3 pt-2">
               <h3 className="text-gray-800 text-md font-semibold">{user.name}</h3>
               <p className="mt-2 font-sans font-light text-gray-600">{user.username}</p>
          </div>
          <div className="flex justify-center pb-3 text-gray-700">
               <div className="text-center">
                    <h2 className="font-semibold">{user.content}</h2>
                    <span className="text-sm text-gray-500">Books</span>
               </div>
          </div>
          <hr />
          {props.children}
     </div>
);
